import { render, staticRenderFns } from "./Transporter.vue?vue&type=template&id=22010e8c"
import script from "./Transporter.vue?vue&type=script&lang=js"
export * from "./Transporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports